export function isValidURL(str: string): boolean {
  try {
    const url = new URL(str);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
}

export function apostrophizeName(name: string | undefined): string {
  const displayName = name || "Anonymous";
  const apostrophe =
    displayName[displayName.length - 1].toLowerCase() === "s" ? "'" : "'s";

  return displayName + apostrophe;
}
